import { useEffect, useState } from "react";
import { ServerService } from "../../services/ServerService";
import Swal from "sweetalert2";
import {FastRechargeService} from "../../services/FastRechargeService";
import {NewLoading} from "../NewLoading";

const RechargeModal = ({ setIsOpen }) => {

    const [serverList, setServerList] = useState([]);
    const [characterList, setCharacterList] = useState([]);
    const [rechargeList, setRechargeList] = useState([]);
    const [createInvoiceLoading, setCreateInvoiceLoading] = useState(false);

    const [formData, setFormData] = useState({
        server_id: 0,
        character_id: 0,
        recharge_coupons_id: 0,
        method: "mercadopago"
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    useEffect(() => {

        const serversLoader = async () => {
            const response = await ServerService().getServerList();
            setServerList(response.data.data.servers);
        };

        serversLoader();
    }, []);

    useEffect(() => {
        if (formData.server_id == 0) {
            return;
        }

        const charactersLoader = async () => {
            Swal.showLoading();
            try {
                const response = await ServerService().getCharactersByUser(formData.server_id);
                setCharacterList(response.data.data.characters);
            } catch (e) {
                console.error(e);
            }
            Swal.close();
        }

        const rechargeLoader = async () => {
            Swal.showLoading();
            try {
                const response = await ServerService().getRechargeCouponList(formData.server_id);
                setRechargeList(response.data.data.rechargeCoupons);
            } catch (e) {
                console.error(e);
            }
            Swal.close();
        }

        charactersLoader();
        rechargeLoader();
    }, [formData.server_id]);

    const handleSubmit = async () => {
        setCreateInvoiceLoading(true);
        try {
            const response = await FastRechargeService().createOrder(formData);

            const url = response.data.data.checkout.url;
            window.open(url, '_blank');

            setIsOpen(false);

            await Swal.fire({
                title: "Redirecionamento realizado",
                text: "Você foi direcionado para a página de pagamento. Por favor, finalize sua compra por lá.",
                icon: "success"
            });
        } catch (e) {
            console.error(e);
            await Swal.fire({
                title: "Eita!",
                text: "Parece que algo deu errado. Fale com o suporte pra resolver isso rapidinho!",
                icon: "warning"
            });
        }
        setCreateInvoiceLoading(false);
    };

    return (<>
        {
            !createInvoiceLoading ? (
                <>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Servidor</label>
                        <select name="server_id" onChange={handleChange}
                                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500">
                            <option selected disabled>Selecione o servidor</option>
                            {
                                serverList.map((item) => (
                                    <option value={item.id}>{item.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    <>
                        {
                            characterList.length > 0 ? (
                                <div className="mb-4">
                                    <label className="block text-gray-700 mb-2">Personagem</label>
                                    <select name="character_id" onChange={handleChange}
                                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500">
                                        <option selected disabled>Selecione o personagem</option>
                                        {
                                            characterList.map((item) => (
                                                <option value={item.UserID}>{item.NickName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            ) : (<></>)
                        }

                        {
                            rechargeList.length > 0 && formData.character_id != 0 ? (
                                <div className="mb-4">
                                    <label className="block text-gray-700 mb-2">Valores</label>
                                    <select name="recharge_coupons_id" onChange={handleChange}
                                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500">
                                        <option selected disabled>Selecione quanto deseja recarregar</option>
                                        {
                                            rechargeList.map((item) => (
                                                <option
                                                    value={item.id}>R$ {(item.price / 100).toFixed(2)} por {item.value} cupons</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            ) : (
                                <></>
                            )
                        }

                        {/* <div className="mb-4">
                <label className="block text-gray-700 mb-2">Método de Pagamento</label>
                <div className="grid grid-cols-2 gap-2">
                    <button
                        className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center justify-center">
                        <i className="fab fa-cc-visa text-blue-600 mr-2"></i> Cartão
                    </button>
                    <button
                        className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center justify-center">
                        <i className="fab fa-paypal text-blue-500 mr-2"></i> PayPal
                    </button>
                    <button
                        className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center justify-center">
                        <i className="fas fa-barcode mr-2"></i> Boleto
                    </button>
                    <button
                        className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center justify-center">
                        <i className="fas fa-mobile-alt mr-2"></i> Celular
                    </button>
                </div>
            </div> */}
                    </>
                    <button onClick={handleSubmit} className="btn-coupons w-full py-2 px-4 text-white font-medium rounded-lg">
                        <i className="fas fa-shopping-cart mr-2"></i> Comprar Cupons
                    </button>
                </>
            ) : (
                <div className={"flex items-center justify-center"}>
                    <NewLoading fillColor={"#d97706"}></NewLoading>
                </div>
            )
        }

        {/* <div className="mb-4">
            <label className="block text-gray-700 mb-2">Valor em Cupons</label>
            <select
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500">
                <option value="1000">1.000 Cupons - R$ 5,00</option>
                <option value="3000">3.000 Cupons - R$ 12,00</option>
                <option value="5000">5.000 Cupons - R$ 18,00</option>
                <option value="10000">10.000 Cupons - R$ 30,00</option>
                <option value="20000">20.000 Cupons - R$ 50,00</option>
            </select>
        </div>
        <div className="mb-4">
            <label className="block text-gray-700 mb-2">Método de Pagamento</label>
            <div className="grid grid-cols-2 gap-2">
                <button
                    className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center justify-center">
                    <i className="fab fa-cc-visa text-blue-600 mr-2"></i> Cartão
                </button>
                <button
                    className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center justify-center">
                    <i className="fab fa-paypal text-blue-500 mr-2"></i> PayPal
                </button>
                <button
                    className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center justify-center">
                    <i className="fas fa-barcode mr-2"></i> Boleto
                </button>
                <button
                    className="p-2 border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center justify-center">
                    <i className="fas fa-mobile-alt mr-2"></i> Celular
                </button>
            </div>
        </div> */}
    </>);
}

export default RechargeModal;